// @flow

import OrderSummaryContainer from './OrderSummaryContainer'

export default OrderSummaryContainer
